import { useEditorViewStore, useSelectionStore } from '@editorStores'
import { PLAN_VIEW_PLAN_ELEMENT_LIST_BY_TYPE } from '../constants'
import { getDisplayedPlanViewTab } from '../utils'
import usePlanViewSelectedElement from './usePlanViewSelectedElement'

/**
 * The plan view's sidebar tab, plus the selected table, comment or image card whose form takes
 * over the sidebar's detail column (tabs included) until it is deselected.
 */
const usePlanViewTab = () => {
  const chosenTab = useEditorViewStore(state => state.planView.tab)
  const setTab = useEditorViewStore(state => state.setPlanViewTab)
  const planElementType = useSelectionStore(state => state.planSelection?.planElementType ?? null)
  const hasSelectedElement = !!usePlanViewSelectedElement()

  const tab = getDisplayedPlanViewTab(chosenTab, hasSelectedElement)
  const planElementDrawerType =
    planElementType && PLAN_VIEW_PLAN_ELEMENT_LIST_BY_TYPE[planElementType] ? planElementType : null

  return { tab, setTab, hasSelectedElement, planElementDrawerType }
}

export default usePlanViewTab
